import { overload } from "../../../shared/src/codecs/types/overload";
import { required } from "../../../shared/src/codecs/types/required";
import { string } from "../../../shared/src/codecs/types/string";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { getPublicPortSuffix } from "../../models/Enviroment";

export const CaseOnboardingUrl = overload(
    string(),
    required({
        id: uuid(),
    }),
    ({id}) =>
        `https://portal.${process.env.SAIL_LEGAL_DOMAIN_NAME}${getPublicPortSuffix("api")}/client/cases/${id}`,
);
export type TCaseOnboardingUrlCodec = typeof CaseOnboardingUrl;
